import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** The statuses before Start Pick, where no pick exists yet and a line's If Short choice is always open. */
export const PRE_PICK_SALES_ORDER_STATUS_IDS = [
    SalesOrderStatus.DRAFT,
    SalesOrderStatus.AWAITING_APPROVAL,
    SalesOrderStatus.SUBMITTED,
];
//# sourceMappingURL=pre-pick-sales-order-status-ids.js.map